interface PrivacyBadgeProps {
  type: 'private' | 'shareable';
  className?: string;
}

export default function PrivacyBadge({ type, className = '' }: PrivacyBadgeProps) {
  if (type === 'private') {
    return (
      <span className={`inline-flex items-center gap-1 text-[10px] text-foreground-400 font-medium ${className}`}>
        <span className="w-3 h-3 flex items-center justify-center">
          <i className="ri-lock-line"></i>
        </span>
        仅自己可见
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1 text-[10px] text-accent-600 font-medium ${className}`}>
      <span className="w-3 h-3 flex items-center justify-center">
        <i className="ri-earth-line"></i>
      </span>
      可公开分享
    </span>
  );
}